// Generated by Melange

import * as StaticAsset from "../../../util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function CountryIcon(Props) {
  let country = Props.country;
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
    case /* COUNTRY_KAZ */ 1 :
      break;
    case /* COUNTRY_KGZ */ 2 :
      return JsxRuntime.jsx("img", {
        className: "rounded-xl",
        src: StaticAsset.src("/static/icons/kyrgyzstan.svg")
      });
    case /* COUNTRY_UZB */ 3 :
      return JsxRuntime.jsx("img", {
        className: "rounded-xl",
        src: StaticAsset.src("/static/icons/uzbekistan.svg")
      });
  }
  return JsxRuntime.jsx("img", {
    src: StaticAsset.src("/static/icons/kazakhstan-round.svg")
  });
}

const make = CountryIcon;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
